export default __webpack_public_path__ + "static/media/edit-img.f297b36f.svg";